import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { App, theme, Typography } from "antd";

import { useVerifyEmailResendMutation } from "../../redux/service.js";
import PrimaryButton from "../../components/PrimaryButton.jsx";
import Input from "../../components/form/Input.jsx";
import { handleErrors } from "@/shared/utils/forms";
import FormField from "../../components/form/FormField.jsx";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const emailVerificationResendSchema = (t) =>
  yup
    .object()
    .shape({
      email: yup
        .string()
        .typeError(t("form.validation.emailNotValid"))
        .email(t("form.validation.enterValidEmail"))
        .required(t("form.validation.enterValidEmail")),
    })
    .required();

const EmailVerificationResend = () => {
  const navigate = useNavigate();
  const { notification } = App.useApp();
  const { token } = theme.useToken();
  const [verifyEmailResend, { isLoading }] = useVerifyEmailResendMutation();
  const { t } = useTranslation();

  const { control, handleSubmit, setError } = useForm({
    resolver: yupResolver(emailVerificationResendSchema(t)),
    mode: "onChange",
  });

  const onSubmit = (values) => {
    verifyEmailResend(values)
      .unwrap()
      .then((data) => {
        notification.success({ message: data.message });
        navigate("/email-verification");
      })
      .catch((errors) => handleErrors(errors, setError, notification));
  };

  return (
    <div className="m-auto form-wrapper" style={{ width: "60%" }}>
      <div
        className="text-center mt-3 mb-4 w-75 m-auto"
        style={{ maxWidth: "400px" }}
      >
        <div className="text-center mb-4 mt-5">
          <Title
            level={3}
            style={{
              color: token.colorPrimaryText,
              fontSize: "clamp(18px, 2vw, 25px)",
            }}
          >
            {t("titles.resendEmailVerification")}
          </Title>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="text-start">
          <div className="mb-3">
            <FormField
              label={t("form.labels.email")}
              required
              field={<Input name="email" control={control} />}
            />
          </div>
          <div className="mt-3 text-center">
            <PrimaryButton
              className="mb-3"
              disabled={isLoading}
              htmlType="submit"
            >
              {t("buttons.submit")}
            </PrimaryButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailVerificationResend;
